export const formatPhoneNumber = (phoneNumber) => {
	return phoneNumber?.match(/.{1,3}/g).map((substring) => substring + ' ');
};
